import { v4 } from "uuid";

export const collectPayAsYouGoClick = async (): Promise<void> => {
    const response = await fetch(process.env.REACT_APP_API_URL + '/v1/user_interactions/pay-as-you-go-clicks', {
        method: 'POST',
        headers: {
            'X-Request-ID': v4()
        }
    });

    if (response.status !== 200) {
        throw new Error('Failed to collect pay as you go click');
    }
}